// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { BankScope } from "./bank-scope";
import { LiftType } from "./lift-type";
import { MessageMatchMode } from "./message-match-mode";
import {
  NotificationRecipient,
  NotificationRecipientT,
  verifyNotificationRecipient,
} from "./notification-recipient";
import { NotificationType } from "./notification-type";
import { TriggerEdge } from "./trigger-edge";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * Notification rule — triggers when a matching LN2 message is received for
 * any bank the rule covers.
 *
 * `match_mode` decides whether that means one exact
 * message, a whole message category, or anything at all. Alerts reach the
 * rule's recipients, which may be literal addresses, named users, or a role
 * resolved to its members at delivery time.
 */
export class Notification implements flatbuffers.IUnpackableObject<NotificationT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Notification {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNotification(bb: flatbuffers.ByteBuffer, obj?: Notification): Notification {
    return (obj || new Notification()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNotification(
    bb: flatbuffers.ByteBuffer,
    obj?: Notification,
  ): Notification {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Notification()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * DEPRECATED as the source of truth — superseded by `bank_ids` below.
   * Still written (with the rule's first bank) because a `(required)` field
   * cannot be removed without breaking readers, and still the only bank a
   * pre-`bank_ids` reader can see. The matching engine MUST NOT read it.
   */
  bankId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  description(): string | null;
  description(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  description(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  type(): NotificationType {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : NotificationType.EMAIL;
  }

  fbsDeviceType(): LiftType {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : LiftType.ELEVATOR;
  }

  encodedType(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageContent(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  messageValue(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  cooldown(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 300;
  }

  minSpan(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 15;
  }

  muted(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  detectedAt(): string | null;
  detectedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  detectedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Self-contained contact destinations for this notification (appended
   * last to preserve `FlatBuffer` backward compatibility).
   */
  recipients(index: number, obj?: NotificationRecipient): NotificationRecipient | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset
      ? (obj || new NotificationRecipient()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  recipientsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Every bank this rule covers, as `notification_banks` join rows.
   *
   * This SUPERSEDES the single `bank_id` above, which is retained only
   * because it is `(required)` and cannot be dropped without breaking
   * readers that predate this field. Producers keep writing `bank_id` with
   * this rule's first bank; the matching engine reads `bank_ids` and must
   * never read `bank_id` again. An empty vector with `bank_scope` LIST
   * means the rule covers `bank_id` alone, which is how every pre-existing
   * row decodes.
   */
  bankIds(index: number, obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset
      ? (obj || new Uuid()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  bankIdsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Whether the rule covers the banks in `bank_ids` or every bank in the
   * organization. ALL_IN_ORG is resolved at delivery time, so a bank added
   * later is covered without editing the rule.
   */
  bankScope(): BankScope {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : BankScope.LIST;
  }

  /**
   * How `message_content` / `message_value` are matched. CATEGORY is the
   * zero value and matches what the engine has always done — it never read
   * `message_value` — so existing rows keep their exact behaviour.
   */
  matchMode(): MessageMatchMode {
    const offset = this.bb!.__offset(this.bb_pos, 46);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : MessageMatchMode.CATEGORY;
  }

  /**
   * Which transition of the message's active flag fires this rule.
   */
  triggerEdge(): TriggerEdge {
    const offset = this.bb!.__offset(this.bb_pos, 48);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : TriggerEdge.ACTIVATED;
  }

  /**
   * Default delivery channels as a bit mask of `NotificationChannel`
   * (EMAIL 1 | SMS 2 | WHATSAPP 4), overridden per recipient by
   * `NotificationRecipient.channels`. 0 means "not set — use the legacy
   * `type`", which is how every pre-existing row decodes.
   */
  channels(): number {
    const offset = this.bb!.__offset(this.bb_pos, 50);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : 0;
  }

  static startNotification(builder: flatbuffers.Builder) {
    builder.startObject(24);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, bankIdOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, organizationIdOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, nameOffset, 0);
  }

  static addDescription(builder: flatbuffers.Builder, descriptionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, descriptionOffset, 0);
  }

  static addType(builder: flatbuffers.Builder, type: NotificationType) {
    builder.addFieldInt8(5, type, NotificationType.EMAIL);
  }

  static addFbsDeviceType(builder: flatbuffers.Builder, fbsDeviceType: LiftType) {
    builder.addFieldInt8(6, fbsDeviceType, LiftType.ELEVATOR);
  }

  static addEncodedType(builder: flatbuffers.Builder, encodedType: number) {
    builder.addFieldInt16(7, encodedType, 0);
  }

  static addMessageContent(builder: flatbuffers.Builder, messageContent: number) {
    builder.addFieldInt16(8, messageContent, 0);
  }

  static addMessageValue(builder: flatbuffers.Builder, messageValue: number) {
    builder.addFieldInt32(9, messageValue, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(10, position, 0);
  }

  static addCooldown(builder: flatbuffers.Builder, cooldown: number) {
    builder.addFieldInt32(11, cooldown, 300);
  }

  static addMinSpan(builder: flatbuffers.Builder, minSpan: number) {
    builder.addFieldInt32(12, minSpan, 15);
  }

  static addMuted(builder: flatbuffers.Builder, muted: boolean) {
    builder.addFieldInt8(13, +muted, +false);
  }

  static addDetectedAt(builder: flatbuffers.Builder, detectedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, detectedAtOffset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(15, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(17, deletedAtOffset, 0);
  }

  static addRecipients(builder: flatbuffers.Builder, recipientsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, recipientsOffset, 0);
  }

  static createRecipientsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startRecipientsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBankIds(builder: flatbuffers.Builder, bankIdsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(19, bankIdsOffset, 0);
  }

  static createBankIdsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startBankIdsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addBankScope(builder: flatbuffers.Builder, bankScope: BankScope) {
    builder.addFieldInt8(20, bankScope, BankScope.LIST);
  }

  static addMatchMode(builder: flatbuffers.Builder, matchMode: MessageMatchMode) {
    builder.addFieldInt8(21, matchMode, MessageMatchMode.CATEGORY);
  }

  static addTriggerEdge(builder: flatbuffers.Builder, triggerEdge: TriggerEdge) {
    builder.addFieldInt8(22, triggerEdge, TriggerEdge.ACTIVATED);
  }

  static addChannels(builder: flatbuffers.Builder, channels: number) {
    builder.addFieldInt8(23, channels, 0);
  }

  static endNotification(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // bank_id
    builder.requiredField(offset, 8); // organization_id
    builder.requiredField(offset, 10); // name
    return offset;
  }

  unpack(): NotificationT {
    return new NotificationT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.bankId() !== null ? this.bankId()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.name(),
      this.description(),
      this.type(),
      this.fbsDeviceType(),
      this.encodedType(),
      this.messageContent(),
      this.messageValue(),
      this.position(),
      this.cooldown(),
      this.minSpan(),
      this.muted(),
      this.detectedAt(),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
      this.bb!.createObjList<NotificationRecipient, NotificationRecipientT>(
        this.recipients.bind(this),
        this.recipientsLength(),
      ),
      this.bb!.createObjList<Uuid, UuidT>(this.bankIds.bind(this), this.bankIdsLength()),
      this.bankScope(),
      this.matchMode(),
      this.triggerEdge(),
      this.channels(),
    );
  }

  unpackTo(_o: NotificationT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.name = this.name();
    _o.description = this.description();
    _o.type = this.type();
    _o.fbsDeviceType = this.fbsDeviceType();
    _o.encodedType = this.encodedType();
    _o.messageContent = this.messageContent();
    _o.messageValue = this.messageValue();
    _o.position = this.position();
    _o.cooldown = this.cooldown();
    _o.minSpan = this.minSpan();
    _o.muted = this.muted();
    _o.detectedAt = this.detectedAt();
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
    _o.recipients = this.bb!.createObjList<NotificationRecipient, NotificationRecipientT>(
      this.recipients.bind(this),
      this.recipientsLength(),
    );
    _o.bankIds = this.bb!.createObjList<Uuid, UuidT>(this.bankIds.bind(this), this.bankIdsLength());
    _o.bankScope = this.bankScope();
    _o.matchMode = this.matchMode();
    _o.triggerEdge = this.triggerEdge();
    _o.channels = this.channels();
  }

  unpackFields(...fields: string[]): NotificationT {
    const t = new NotificationT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId() !== null ? this.bankId()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("description")) {
      t.description = this.description();
    }
    if (fieldSet.has("type")) {
      t.type = this.type();
    }
    if (fieldSet.has("fbs_device_type")) {
      t.fbsDeviceType = this.fbsDeviceType();
    }
    if (fieldSet.has("encoded_type")) {
      t.encodedType = this.encodedType();
    }
    if (fieldSet.has("message_content")) {
      t.messageContent = this.messageContent();
    }
    if (fieldSet.has("message_value")) {
      t.messageValue = this.messageValue();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    if (fieldSet.has("cooldown")) {
      t.cooldown = this.cooldown();
    }
    if (fieldSet.has("min_span")) {
      t.minSpan = this.minSpan();
    }
    if (fieldSet.has("muted")) {
      t.muted = this.muted();
    }
    if (fieldSet.has("detected_at")) {
      t.detectedAt = this.detectedAt();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    if (fieldSet.has("recipients")) {
      t.recipients = this.bb!.createObjList<NotificationRecipient, NotificationRecipientT>(
        this.recipients.bind(this),
        this.recipientsLength(),
      );
    }
    if (fieldSet.has("bank_ids")) {
      t.bankIds = this.bb!.createObjList<Uuid, UuidT>(
        this.bankIds.bind(this),
        this.bankIdsLength(),
      );
    }
    if (fieldSet.has("bank_scope")) {
      t.bankScope = this.bankScope();
    }
    if (fieldSet.has("match_mode")) {
      t.matchMode = this.matchMode();
    }
    if (fieldSet.has("trigger_edge")) {
      t.triggerEdge = this.triggerEdge();
    }
    if (fieldSet.has("channels")) {
      t.channels = this.channels();
    }
    return t;
  }
}

export class NotificationT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public bankId: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public name: string | Uint8Array | null = null,
    public description: string | Uint8Array | null = null,
    public type: NotificationType = NotificationType.EMAIL,
    public fbsDeviceType: LiftType = LiftType.ELEVATOR,
    public encodedType: number = 0,
    public messageContent: number = 0,
    public messageValue: number = 0,
    public position: number = 0,
    public cooldown: number = 300,
    public minSpan: number = 15,
    public muted: boolean = false,
    public detectedAt: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
    public recipients: NotificationRecipientT[] = [],
    public bankIds: UuidT[] = [],
    public bankScope: BankScope = BankScope.LIST,
    public matchMode: MessageMatchMode = MessageMatchMode.CATEGORY,
    public triggerEdge: TriggerEdge = TriggerEdge.ACTIVATED,
    public channels: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.bankId === null || this.bankId === undefined) {
      throw new Error('Required field "bank_id" is not set');
    }
    if (this.organizationId === null || this.organizationId === undefined) {
      throw new Error('Required field "organization_id" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const bankId = this.bankId !== null ? this.bankId!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const description = this.description !== null ? builder.createString(this.description!) : 0;
    const detectedAt = this.detectedAt !== null ? builder.createString(this.detectedAt!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;
    const recipients = Notification.createRecipientsVector(
      builder,
      builder.createObjectOffsetList(this.recipients),
    );
    const bankIds = Notification.createBankIdsVector(
      builder,
      builder.createObjectOffsetList(this.bankIds),
    );

    Notification.startNotification(builder);
    Notification.addId(builder, id);
    Notification.addBankId(builder, bankId);
    Notification.addOrganizationId(builder, organizationId);
    Notification.addName(builder, name);
    Notification.addDescription(builder, description);
    Notification.addType(builder, this.type);
    Notification.addFbsDeviceType(builder, this.fbsDeviceType);
    Notification.addEncodedType(builder, this.encodedType);
    Notification.addMessageContent(builder, this.messageContent);
    Notification.addMessageValue(builder, this.messageValue);
    Notification.addPosition(builder, this.position);
    Notification.addCooldown(builder, this.cooldown);
    Notification.addMinSpan(builder, this.minSpan);
    Notification.addMuted(builder, this.muted);
    Notification.addDetectedAt(builder, detectedAt);
    Notification.addCreatedAt(builder, createdAt);
    Notification.addUpdatedAt(builder, updatedAt);
    Notification.addDeletedAt(builder, deletedAt);
    Notification.addRecipients(builder, recipients);
    Notification.addBankIds(builder, bankIds);
    Notification.addBankScope(builder, this.bankScope);
    Notification.addMatchMode(builder, this.matchMode);
    Notification.addTriggerEdge(builder, this.triggerEdge);
    Notification.addChannels(builder, this.channels);

    return Notification.endNotification(builder);
  }

  clone(): NotificationT {
    const obj = new NotificationT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.bankId = this.bankId !== null ? this.bankId!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.name = this.name;
    obj.description = this.description;
    obj.type = this.type;
    obj.fbsDeviceType = this.fbsDeviceType;
    obj.encodedType = this.encodedType;
    obj.messageContent = this.messageContent;
    obj.messageValue = this.messageValue;
    obj.position = this.position;
    obj.cooldown = this.cooldown;
    obj.minSpan = this.minSpan;
    obj.muted = this.muted;
    obj.detectedAt = this.detectedAt;
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    obj.recipients = this.recipients.map((e) => e.clone());
    obj.bankIds = this.bankIds.map((e) => e.clone());
    obj.bankScope = this.bankScope;
    obj.matchMode = this.matchMode;
    obj.triggerEdge = this.triggerEdge;
    obj.channels = this.channels;
    return obj;
  }

  equals(other: NotificationT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.bankId !== null && other.bankId !== null) {
      if (!this.bankId!.equals(other.bankId!)) return false;
    } else if (this.bankId !== other.bankId) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.name !== other.name) return false;
    if (this.description !== other.description) return false;
    if (this.type !== other.type) return false;
    if (this.fbsDeviceType !== other.fbsDeviceType) return false;
    if (this.encodedType !== other.encodedType) return false;
    if (this.messageContent !== other.messageContent) return false;
    if (this.messageValue !== other.messageValue) return false;
    if (this.position !== other.position) return false;
    if (this.cooldown !== other.cooldown) return false;
    if (this.minSpan !== other.minSpan) return false;
    if (this.muted !== other.muted) return false;
    if (this.detectedAt !== other.detectedAt) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    if (this.recipients.length !== other.recipients.length) return false;
    for (let i = 0; i < this.recipients.length; i++) {
      const a = this.recipients[i];
      const b = other.recipients[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.bankIds.length !== other.bankIds.length) return false;
    for (let i = 0; i < this.bankIds.length; i++) {
      const a = this.bankIds[i];
      const b = other.bankIds[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.bankScope !== other.bankScope) return false;
    if (this.matchMode !== other.matchMode) return false;
    if (this.triggerEdge !== other.triggerEdge) return false;
    if (this.channels !== other.channels) return false;
    return true;
  }
}

export function verifyNotification(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "bank_id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "organization_id");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 1);
    verifier.checkScalarField(tablePos, 16, 1);
    verifier.checkScalarField(tablePos, 18, 2);
    verifier.checkScalarField(tablePos, 20, 2);
    verifier.checkScalarField(tablePos, 22, 4);
    verifier.checkScalarField(tablePos, 24, 2);
    verifier.checkScalarField(tablePos, 26, 4);
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 34);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 38);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyNotificationRecipient);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 42);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyUuid);
      }
    }
    verifier.checkScalarField(tablePos, 44, 1);
    verifier.checkScalarField(tablePos, 46, 1);
    verifier.checkScalarField(tablePos, 48, 1);
    verifier.checkScalarField(tablePos, 50, 1);
  } finally {
    verifier.popDepth();
  }
}
